module.exports = __webpack_public_path__ + "static/media/pt_ongoing2.45f8969a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/pt_ongoing2.svg
// module id = 1814
// module chunks = 0